"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.form.title.edit': 'Edytuj Krok',
    'step.form.title.add': 'Dodaj Krok',
    'step.form.back': 'Wstecz',
    'step.form.title.label': 'Tytuł',
    'step.form.title.placeholder': 'Tytuł kroku',
    'step.form.order.label': 'Kolejność',
    'step.form.order.placeholder': 'Kolejność kroku',
    'step.form.isShared.label': 'Krok Współdzielony',
    'step.form.profession.label': 'Zawód',
    'step.form.profession.placeholder': 'Wybierz zawód',
    'step.form.description.label': 'Opis',
    'step.form.description.placeholder': 'Opis',
    'step.form.questions.title': 'Pytania',
    'step.form.questions.add': 'Dodaj Pytanie',
    'step.form.questions.remove': 'Usuń',
    'step.form.questions.empty': 'Nie dodano jeszcze żadnych pytań. Kliknij "Dodaj Pytanie", aby rozpocząć.',
    'step.form.questions.order': 'Pytanie',
    'step.form.submit.update': 'Zaktualizuj Krok',
    'step.form.submit.create': 'Utwórz Krok',
};
